import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { useUserDetailProfile } from './hooks';
import { convertToPresentationProps } from './logics';
import { UserDetailProfilePresentation } from './presentations';

type Props = {
  /** 利用者ID */
  userId: number;
};

/**
 * 利用者詳細プロフィール Container
 *
 * - API から利用者情報を取得してプロフィールとして表示する
 * - isActivationCodeEnabled（= enableStaging || enableInternal）を Container で判定し、Presentation に渡す
 * - カスタムフィールドはプロフィール API の custom_field_values をそのまま使って表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const UserDetailProfile: React.FC<Props> = ({ userId }) => {
  const { enableStaging, enableInternal } = getEnvFeatureFlag();
  const isActivationCodeEnabled = enableStaging || enableInternal;

  const {
    state: { data, profileData },
  } = useUserDetailProfile(userId);

  const {
    fullName,
    email,
    clientName,
    billableFromLabel,
    createdAtLabel,
    updatedAtLabel,
    editLink,
    activationCode,
    phoneNumber,
    customFields,
  } = convertToPresentationProps({
    data,
    userId,
    profileData,
  });

  return (
    <UserDetailProfilePresentation
      fullName={fullName}
      email={email}
      clientName={clientName}
      billableFromLabel={billableFromLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
      editLink={editLink}
      isActivationCodeEnabled={isActivationCodeEnabled}
      activationCode={activationCode}
      phoneNumber={phoneNumber}
      customFields={customFields}
    />
  );
};
